import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogService, ErrorResponseMessage} from '@rbaip/ui-component';
import {Asset} from '../../shared/domain/item';
import {Subscription} from 'rxjs';
import {ItemSummaryItemService} from '../../shared/asset/item-summary-item.service';
import {Contact} from '@rbaip/address-form';
import {ItemSummaryContactInfoService} from '../../shared/contact/item-summary-contact-info.service';
import {ItemSummaryAssetContactInfoServiceImpl} from '../../shared/contact/item-summary-asset-contact-info-impl.service';
import {SellerContractContactType} from '../../shared/contact/seller-contract-contact-type.enum';
import {ContactEditComponent} from '../../contact/contact-edit/contact-edit.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-item-summary-consignor-contact',
  templateUrl: './consignor-contact.component.html',
  styleUrls: ['./consignor-contact.component.scss'],
  providers: [
    { provide: ItemSummaryContactInfoService, useClass: ItemSummaryAssetContactInfoServiceImpl }
  ]
})
export class ConsignorContactComponent implements OnInit, OnDestroy {

  private itemService: ItemSummaryItemService;
  public sellerContractContactType = SellerContractContactType;
  public loadAssetContact: boolean;
  itemId: number;
  asset: Asset;
  private assetInfoServiceSubscription: Subscription;

  constructor(private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA)  private data: any,
              private contactInfoService: ItemSummaryContactInfoService,
              private dialogService: DialogService) {
    this.itemId = data.itemId;
    this.itemService = data.itemService;
  }

  ngOnInit() {
    this.subscribeServices();
    this.init();
  }

  private subscribeServices() {
    this.subscribeAssetInfo();
  }

  private subscribeAssetInfo() {
    this.assetInfoServiceSubscription = this.itemService.assetServiceCallback.subscribe(assetInfo => {
        this.asset = assetInfo;
        this.asset.legalContact = Object.assign(new Contact(), this.asset.legalContact);
        this.loadAssetContact = true;
        this.asset.prepareContractContacts();
      }
    );
  }

  private init() {
    setTimeout(() => {
      this.itemService.getAsset(this.itemId);
    });
  }

  ngOnDestroy() {
    if (this.assetInfoServiceSubscription) {
      this.assetInfoServiceSubscription.unsubscribe();
    }
  }

  public addOrEditContact(event: {contact: Contact, contactType: string}) {
    const {contact, contactType} = event;
    const dialogRef = this.dialog.open(ContactEditComponent, {
      panelClass: 'mat-panel--full-height',
      data: {
        editing: true,
        contact: contact.clone(),
        contactType,
        updateService: this.contactInfoService,
        asset: this.asset
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.refresh();
    });
  }

  public deleteContact(event: {contact: Contact, contactType: string}) {
    const {contact, contactType} = event;
    this.dialogService.showProgress();
    const eventId = this.asset.auctionEventId;
    const equipId = this.asset.equipId;
    this.contactInfoService.deleteContact(eventId, equipId, contact.cntctId, contactType)
      .subscribe(response => {
        response = response as ErrorResponseMessage;
        if (response && response.error) {
          this.dialogService.showMessage(response.getErrorMessage() ? response.getErrorMessage() : 'Failed to delete contract contact info!');
        } else {
          this.refresh();
        }
        this.dialogService.hideProgress();
      });
  }

  private refresh() {
    this.itemService.getAsset(this.itemId);
  }
}
